export default {
  profile: 'Profile',
  settings: 'Settings',
  createContentTip: 'Content created will belong to {label}. Please enter in {label}.',
  createContentExample: 'e.g. when creating a product, use',
  langLevel: 'Base: {label}',
};
